((Redactor) => {
  Redactor.add("plugin", "ads", {
    translations: {
      en: {
        ads: I18n.t("redactor_google_ad"),
        "ads-label": I18n.t("redactor_google_ad_label"),
      },
      ru: {
        ads: I18n.t("redactor_google_ad"),
        "ads-label": I18n.t("redactor_google_ad_label"),
      },
    },

    init(app) {
      this.app = app;
      this.lang = app.lang;
      this.toolbar = app.toolbar;
      this.marker = app.marker;
      this.selection = app.selection;
      this.insertion = app.insertion;
      this.component = app.component;
      this.inspector = app.inspector;
    },

    start() {
      const buttonData = {
        title: this.lang.get("ads"),
        api: "plugin.ads.insertAd",
      };
      this.toolbar.addButton("ads", buttonData);
    },

    insertAd() {
      const marker = this.marker.insert("start");
      const $marker = Redactor.dom(marker);

      const adWrapper = document.createElement("figure");
      adWrapper.className = "redactor-ads tc";
      adWrapper.setAttribute("contenteditable", "false");
      adWrapper.setAttribute("data-redactor-type", "component");
      adWrapper.style.cssText = "margin: 16px 0; padding: 20px; background: #f5f5f5; border: 2px dashed #ccc; text-align: center; color: #666;";
      adWrapper.innerHTML = "||google_ad||";

      $marker.before(adWrapper);

      const br = document.createElement("br");
      $marker.before(br);

      this.selection.restoreMarkers();
    },

    // Handle component edit/delete from Redactor's native controls
    "component.edit"(component) {
      if (component.classList.contains("redactor-ads")) {
        // Google ads don't need editing, just show info
        alert(this.lang.get("ads-label"));
      }
    },

    remove(node) {
      this.component.remove(node);
    },

    oncontextbar(e, contextbar) {
      const data = this.inspector.parse(e.target);
      if (!data.isFigcaption() && data.isComponentType("component")) {
        const node = data.getComponent();
        if (node && node.classList.contains("redactor-ads")) {
          const buttons = {
            remove: {
              title: this.lang.get("delete"),
              api: "plugin.ads.remove",
              args: node,
            },
          };

          contextbar.set(e, node, buttons, "bottom");
        }
      }
    },
  });
})(Redactor);